import React from 'react'
import App from 'next/app'
import { appWithTranslation } from '../i18n'
import * as Sentry from '@sentry/node'
import '../styles/app.scss'
import '../static/fonts/font.css'
import '@microfrontends/react-components/public/index.css'
import '@microfrontends/app-shell-v2/dist/index.css'
import 'cropperjs/dist/cropper.css'

import { I18n, TFunction } from 'next-i18next'

const SENTRY_DSN = process.browser
	? process.env.SENTRY_CLIENT_DSN
	: process.env.SENTRY_SERVER_DSN
const SENTRY_ENABLED = process.env.NODE_ENV === 'production' || process.browser

Sentry.init({
	dsn: SENTRY_DSN,
	enabled: SENTRY_ENABLED
})
export interface IPageProps {
	hiddenMenu: number[]
	i18n: I18n
	t: TFunction
	user: any
}
class MyApp extends App {
	render() {
		const { Component, pageProps } = this.props
		// Workaround for https://github.com/zeit/next.js/issues/8592
		// @ts-ignore
		const { err } = this.props
		const modifiedPageProps = { ...pageProps, err }
		return <Component {...modifiedPageProps} />
	}
}

export default appWithTranslation(MyApp)
